import React from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function PreviewFile(props) {
  const {
    file,
    handleClose = () => {},
  } = props;

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="file-viewer-header">
            <div className="application-form-header">
              <div className="breadcrumbs">
                <span className="breadcrumbs-current">
                  Просмотр файла
                </span>
              </div>
            </div>
          </div>
        )}
        title={<Icons onClick={handleClose} customIcon icon="close" className="close" />}
      />
      <DialogContent>
        {file ? <iframe title="Просмотр файла" src={file} frameBorder="0" width="100%" height="100%" /> : null}
        {!file ? <div className="file-not-found">Файл не найден</div> : null}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        <div className="ms-auto" />
        <Button variant="secondary" onClick={handleClose}>Отмена</Button>
      </DialogFooter>
    </Dialog>
  );
}
